(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/match.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs = svs || {};
  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var MatchModel = _.extend({}, svs.statistics.mixins.SocketSubscriber, {
    logger: new svs.core.log.Logger('svs.statistics.models.Match'),

    url: function() {
      return svs.core.jupiter.url() + this.socketResourcePath;
    },

    initialize: function(model, options) {
      this.options = _.extend(
        {
          showDateInInit: false
        },
        options
      );

      this.listenTo(this, 'change', this.onModelChanged);

      this.socketResourcePath =
        '/sport/1/matches/' + this.get('matchId') + '/matchlist';

      var sportId = (this.get('sport') || this.get('league').sport).id || null;

      if (sportId && options.parse !== false) {
        this.parse(model);
      } else {
        if (options.fetch !== false) {
          this.fetch();
        }
      }

      if (options.subscribe) {
        this.startPush();
      }
    },

    onModelChanged: function() {
      this.set('isShowOdds', this.isShowOdds());
    },

    isShowOdds: function() {
      var status = this.get('status'),
        isEnded = this.getStatusFunction('isEnded', status),
        isVisualLimitedCoverage = this.get('isVisualLimitedCoverage'),
        isLive = this.getStatusFunction('isLive', status),
        oddsModel = this.get('oddsModel'),
        odds = this.get('odds');

      if (!odds && !oddsModel) {
        return false;
      }

      if (
        isEnded ||
        isVisualLimitedCoverage ||
        (isLive && !oddsModel.get('showLiveOdds'))
      ) {
        return false;
      }
      return true;
    },

    generateInit: function() {
      var init = {
        opt: {
          tv: false, 
          live: false, 
          spelstopp: false, 
          date: this.options.showDateInInit 
        },
        startTime: '',
        status: {
          id: null,
          realTime: 0
        }, 
        matchId: null,
        sport: null,
        error: false
      };

      if (this.get('media') && this.get('media').length !== 0) {
        init.opt.tv = this.get('media');
      }

      if (_.isObject(this.get('oddsetDraws'))) {
        if (
          this.get('oddsetDraws').isLiveDraw ||
          this.get('oddsetDraws').hasLiveDraw
        ) {
          init.opt.live = true;
        }
      }

      if (this.get('actualStartTime')) {
        init.startTime = this.get('actualStartTime');
      } else if (this.get('startTime')) {
        init.startTime = this.get('startTime');
      }

      if (_.isNumber(this.get('status'))) {
        init.status.id = this.get('status');
      }
      if (this.get('statusTime')) {
        init.status.realTime = this.get('statusTime');
      }

      if (this.get('matchId')) {
        init.matchId = this.get('matchId');
      }

      init.sport = this.get('sport');

      init.error =
        this.get('lazy') ||
        this.isVisualLimitedCoverage(
          this.get('coverage'),
          init.startTime,
          this.get('status')
        );

      if (init.error || this.getStatusFunction('isEnded', this.get('status'))) {
        init.opt.live = false;
        init.opt.tv = false;
      }

      return init;
    },

    noTemplate: function() {
      var noTemplate = true;

      this.initTheme(this.get('sport'));

      if (
        this.theme.exist([
          'mini-statistics-after',
          'mini-statistics-before',
          'stat-match-events',
          'stat-match-statistics',
          'stat-match-lineup'
        ])
      ) {
        noTemplate = false;
      }

      return noTemplate;
    },

    isVisualLimitedCoverage: function(coverage, startTime, status) {
      if (coverage === 1) {
        return false;
      }

      var now = moment(),
        isEnded = this.getStatusFunction('isEnded', status);
      startTime = moment(startTime);

      return now.isAfter(startTime) && !isEnded && coverage === 0;
    },

    setLowCoverageInterval: function(startTime, status) {
      if (this.lowCoverageIntervalStarted) {
        return false;
      }

      var now = moment(),
        isEnded = this.getStatusFunction('isEnded', status),
        _self = this;
      startTime = moment(startTime);

      if (
        !this.lowCoverageIntervalStarted &&
        now.isBefore(startTime) &&
        !isEnded
      ) {
        if (startTime.isBefore(moment().add(24, 'days'))) {

          this.lowCoverageIntervalStarted = setTimeout(function() {
            _self.logger.debug('Low coverage match trigger change.');
            _self.set({ isVisualLimitedCoverage: true }, { silent: true });
            _self.set({ init: _self.generateInit() }, { silent: true });
            _self.trigger('change', _self);
          }, startTime.add(1, 'seconds').diff(now)); 
        }

        return true;
      }

      return false;
    },

    isMatchLazy: function() {
      this.initTheme(this.get('sport'));

      return this.getStatusFunction('isLazy', this);
    },

    parse: function(response) {
      if (_.isObject(response.match)) {
        response = response.match;
      }

      this.set(response, { silent: true });
      this.set('response', response, { silent: true });

      if (
        _.isObject(this.get('league')) &&
        _.isObject(this.get('league').sport)
      ) {
        this.set('sport', this.get('league').sport.id, { silent: true });
      } else {
        this.set('sport', this.get('sport').id, { silent: true });
      }

      this.set({ lazy: this.isMatchLazy() }, { silent: true });
      this.set({ init: this.generateInit() }, { silent: true });
      this.set('noTemplate', this.noTemplate(), { silent: true });
      this.set(
        {
          isVisualLimitedCoverage: this.isVisualLimitedCoverage(
            this.get('coverage'),
            this.get('actualStartTime') || this.get('startTime'),
            this.get('status')
          )
        },
        { silent: true }
      );

      if (!this.get('coverage')) {
        this.setLowCoverageInterval(
          this.get('actualStartTime') || this.get('startTime'),
          this.get('status')
        );
      }

      this.trigger('change', this);

      if (
        this.getStatusFunction('subscribeMatch', {
          time: this.get('startTime'),
          status: this.get('status')
        }) ||
        this.isMock
      ) {
        this.startPush();
      }
      if (this.getStatusFunction('isEnded', this.get('status'))) {
      }

      return response;
    },

    onSocketUpdate: function(param) {
      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('MATCH', param.match);
      }

      if (_.isObject(param)) {
        param.match = param.match || {};
        param.match.league = param.match.league || {};
        param.match.league.sport =
          param.match.sport || param.match.league.sport;
        this.parse(param);
      }
    },

    startPush: function() {
      this.subscribe(this.socketResourcePath, this.onSocketUpdate, true);
    },

    stopPush: function() {
      this.unsubscribe();
    },

    initTheme: function(sport) {
      if (!this.theme) {
        this.theme = new svs.sport.themeLoader({ sport: sport });
      }
    },

    getStatusFunction: function(func, params) {
      var returner = false;

      this.initTheme(this.get('sport'));

      this.theme.load(function(template, init) {
        if (init) {
          returner = init(func, params);
        }
      }, 'init');

      return returner;
    }
  });

  svs.statistics.models.Match = Backbone.Model.extend(MatchModel);
})(Backbone, _, svs);

 })(window);